import { HttpRequest } from "../Config/APIConnection";
export const CheckHistoryDonnor = async ({ IdentityID }) => {
  return await HttpRequest("GET", `/SyncDonnor/History?IdentityID=${IdentityID}`);
};
